import {makeDefaultEmpty} from '../../components/DefaultEmpty';

export const mainComponentsMap = {
    SectionCollectionsEnabled: makeDefaultEmpty<{}>(),
} as const;
